import { combineReducers } from "redux";
import { appSettingsReducer } from "./appSettingsReducer";
import { addressingResultReducer } from "./addressingResultReducer";
import { mapPanelControlReducer } from "./mapPanelControlReducer";
import { addressDetailsReducer } from './addressDetailsReducer'

import { addressIssueTypesReducer } from './addressIssueTypesReducer'
import { addressIssueStatusTypesReducer } from './addressIssueStatusTypesReducer'
const reducer = combineReducers({
  settings: appSettingsReducer,
  addressingResult : addressingResultReducer,
  addressIssueTypes : addressIssueTypesReducer,
  addressIssueStatusTypes : addressIssueStatusTypesReducer,
  mapPanelSetting: mapPanelControlReducer,
  addressDetails : addressDetailsReducer
});

export default reducer;
